import * as  React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import MainHeader from '../../../headers/MainHeader/MainHeader';
import * as actions from '../../../../redux/projects/actions.projects';
import EmbedCodeForm from '../EmbedCodeForm/EmbedCodeForm';
import projectHelper from '../../../../services/ProjectHelper';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import getProjectId from '../../../../services/mini/getProjectId';
import EmbedHeader from '../EmbedHeader';
import { IProject } from '../../../../models/IProject';
import { IGetProjectInfoParams, IGetPropjectParam } from '../../../../redux/projects/saga.projects';

type EmbedPageProps = {
    project: IProject,
    projectId: string,
    isProjectResetting: boolean,
    tier: string,
    resetProject: () => void,
    getProjectDetail: (param: IGetProjectInfoParams) => void,
}

function EmbedPage({
    project,
    projectId,
    isProjectResetting,
    resetProject,
    getProjectDetail,
    tier
}: EmbedPageProps) {

    const environment = projectHelper.getEnvironment(projectId);

    useEffect(() => {
        getProjectDetail({ projectId, environment });
    }, [environment, projectId, getProjectDetail]);

    return <div className="embed-page">
        <MainHeader environment={environment} >
            <EmbedHeader environment={environment} />
        </MainHeader>

        <div className="embed-page_body">
            {project && project.createTs &&
                <EmbedCodeForm
                    projectId={projectId}
                    project={project}
                    isProjectResetting={isProjectResetting}
                    resetProject={resetProject}
                    environment={environment}
                    tier={tier} />}
        </div>
    </div>;
}

function mapStateToProps({ projectsInfo, user }, ownProps) {
    return {
        projectId: getProjectId(ownProps.params.projectName, projectsInfo.projects),
        project: projectsInfo.currentProject,
        isProjectResetting: projectsInfo.isProjectResetting,
        tier: user.tier,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getProjectDetail: (param) => dispatch(actions.getProjectInfo(param)),
        resetProject: () => asyncDispatch(actions.resetProject, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmbedPage);
